import { ButtonLink } from "../components/Button";
import {
  // SubtitleWrapper,
  TextShadeWrapper,
  TitleWrapper,
} from "../components/Wrappers";
import { AMAZON_STORE_LINK } from "../constants";

const BuyBook = () => {
  return (
    <div className="buybook">
      <div className="buybook__container">
        <TitleWrapper textAlign="center" textAlignSm="left" lineHeight="49px">
          Get Your Book <TextShadeWrapper>Copy Today</TextShadeWrapper>
        </TitleWrapper>
        {/* <SubtitleWrapper
          marginTop="15px"
          marginBottom="32px"
          maxWidth="555px"
          textAlign="center"
          textAlignSm="left"
          lineHeight="30px"
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Volutpat dui,
          velit nibh dui, cras commodo tincidunt a elementum. Cursus ac mollis
          pretium
        </SubtitleWrapper> */}
        <ButtonLink
          primaryBtn
          href={AMAZON_STORE_LINK}
          widthSm="100%"
          marginTop="32px"
        >
          Buy the Book
        </ButtonLink>
      </div>
    </div>
  );
};

export default BuyBook;
